import type { ReactNode } from 'react';

import { FormattedContent } from 'atoms/formatted-content';

import css from './styles.module.css';

import raw from './_ingress.md' with { type: 'text' };

export default function Ingress(): ReactNode {
	return (
		<main className={css.wrapper}>
			<article data-scroll-reveal className={css.wrap}>
				<FormattedContent raw={raw} />
			</article>
		</main>
	);
}
